import { cfg } from '../config';
import ol from 'openlayers';

export class BasemapController {


    private states: { name: string, image: string, layer: ol.layer.Layer }[] = [];
    private currentStateIndex: number = 0;
    private imageDom: HTMLImageElement;

    constructor(parent: HTMLDivElement) {
        let newDomItem = document.createElement("div");
        newDomItem.className = 'basemap-selector';
        newDomItem.title = "toggle base mapping";
        newDomItem.addEventListener("click", () => {
            this.toggle();
        })



        parent.appendChild(newDomItem);

        this.states = [
            {
                name: "OSM",
                image: cfg.name + ".thumb_basemap_osm.jpg",
                layer: new ol.layer.Tile({
                    source: new ol.source.OSM(
                        {
                            attributions: '<span style="font-family:Arial;">&copy; <span style="font-weight:bold;">maploom</span>, &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors</span>'
                        }
                    )
                })
            },
            {
                name: "HERE",
                image: cfg.name + ".thumb_basemap_here.jpg",
                layer: new ol.layer.Tile({
                    visible: false,
                    preload: Infinity,
                    source: new ol.source.XYZ({
                        url: `https://www.maploom.com/api/rest/v1/theme/imagery/tms/here.satellite/{y}/{x}/{1-4}/{z}`,
                        attributions: '<span style="font-family:Arial;">&copy; <span style="font-weight:bold;">maploom</span>, Map Tiles &copy; ' + new Date().getFullYear() + ' ' +
                            '<a href="http://developer.here.com">HERE</a></span>'
                    })
                })
            }
        ]


        this.imageDom = document.createElement("img");
        this.imageDom.src = this.image;
        newDomItem.appendChild(this.imageDom);
    }

    get image() {
        return cfg.apiUrlBase + "/static/" + this.states.filter((v, i) => i !== this.currentStateIndex)[0].image;
    }

    get layers(): ol.layer.Layer[] {
        return this.states.map(s => s.layer);
    }

    private toggle() {
        // console.log('toggle');
        this.currentStateIndex = (this.currentStateIndex === 0) ? 1 : 0;
        this.states[0].layer.setVisible(0 === this.currentStateIndex)
        this.states[1].layer.setVisible(1 === this.currentStateIndex)
        this.imageDom.src = this.image;
    }

}